import axios from 'axios'

class Antifraud {
  async search (filter) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers?`
    var queryStringElements = 0
    const situation = (filter.situation.length === 0 ? `` : `situation[0]=${filter.situation[0]}`)
    if (filter.situation.length !== 0) {
      queryStringElements++
    }
    const taxDocument = (filter.taxDocument === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}taxDocument=${filter.taxDocument}`)
    if (filter.taxDocument !== '') {
      queryStringElements++
    }
    const fullName = (filter.fullName === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}fullName=${filter.fullName}`)
    if (filter.fullName !== '') {
      queryStringElements++
    }
    const email = (filter.email === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}email=${filter.email}`)
    if (filter.email !== '') {
      queryStringElements++
    }
    const partnerId = (filter.partnerId === '' ? `` : `${queryStringElements !== 0 ? '&' : ''}partnerId=${filter.partnerId}`)
    if (filter.partnerId !== '') {
      queryStringElements++
    }
    const offset = `${queryStringElements !== 0 ? '&' : ''}index=${filter.offset.index}&length=${filter.offset.limit}`
    const result = await axios.get(`${url}${situation}${taxDocument}${fullName}${email}${partnerId}${offset}`)
    return result.data
  }

  async timeline (hashId) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${hashId}/timeline`
    const result = await axios.get(url)
    return result.data
  }

  async activate (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/account/${hashId}/activate`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async approve (hashId) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${hashId}/approve`
    let model = { appUrl: `${process.env.BUSINESS_URL}` }
    const result = await axios.post(url, model)
    return result.data
  }

  async blacklist (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${hashId}/blacklist`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async whitelist (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${hashId}/whitelist`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async block (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/account/${hashId}/balance/block`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async unblock (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/account/${hashId}/balance/unblock`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async deactive (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/account/${hashId}/deactivate`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async disapprove (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${hashId}/disapprove`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }

  async notify (hashId, reason) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${hashId}/notify`
    let model = { reason: reason }
    const result = await axios.post(url, model)
    return result.data
  }
}

class Sellers {
  async list (filter) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers`
    const result = await axios.get(url, {
      params: {
        fullName: filter.fullName,
        email: filter.email,
        taxDocument: filter.taxDocument,
        situation: filter.situation,
        index: filter.index,
        length: filter.length,
        partnerId: filter.partnerId
      }
    })

    return result.data
  }
  async find (sellerId) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/sellers/${sellerId}`
    const result = await axios.get(url)
    return result.data
  }
  async findSelfie (sellerId) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${sellerId}/selfie`
    const result = await axios.get(url, {
      responseType: 'arraybuffer'
    })
    return result
  }
  async findDocumentFront (sellerId) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${sellerId}/document-front`
    const result = await axios.get(url, {
      responseType: 'arraybuffer'
    })
    return result
  }
  async findDocumentBack (sellerId) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/antifraud/sellers/${sellerId}/document-back`
    const result = await axios.get(url, {
      responseType: 'arraybuffer'
    })
    return result
  }
  async getpartners () {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/partners`
    const model = {}
    const result = await axios.post(url, model)
    return result.data
  }
  async searchPartners (parameter) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/partners`
    const model = {
      fullName: parameter
    }

    const result = await axios.post(url, model)
    return result.data
  }
}

export default class AccountApi {
  antifraud = new Antifraud()
  sellers = new Sellers()

  async signin (user) {
    const url = `${process.env.VUE_APP_ACOUNT_API_URL}/${process.env.VUE_APP_APPLICATION_ID}/signin`
    const result = await axios.post(url, { login: user.email, password: user.password })

    return result.data
  }

  async whoAmI () {
    const result = await axios.get(`${process.env.VUE_APP_ACOUNT_API_URL}/whoami`)

    return result.data
  }
}
